import React from "react";
import Accordions from "../../../components/Accordions";

const Sem1FSE1 = () => {
  const data = [
    {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1w0UGisLaB-ZC_jDHLxTsYF8uvihHE_C3/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">SFE Sem - 1</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem1FSE1;
